import { IsNotEmpty, IsString } from 'class-validator';

export class FeatureTypeForm {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsNotEmpty()
  value: string;
}
